import React, { useState, useEffect } from "react";
import {
  Button,
  Row,
  Col,
  Typography,
  Card,
  Divider,
  Carousel,
  List,
} from "antd";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/navbar/index.jsx";
import {
  PieChartOutlined,
  TeamOutlined,
  BarChartOutlined,
  RocketOutlined,
  BookOutlined,
  LeftOutlined,
  RightOutlined,
  ToolOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  UserOutlined,
  BankOutlined,
  MessageOutlined,
  MoneyCollectOutlined,
  BulbOutlined,
  FundOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { Box } from "@mui/material";
import "./Shark.css";

// Importing the image files
import whyChooseImage1 from "../../assets/images/Be-aShark-Launch-day.jpg";
import whyChooseImage7 from "../../assets/images/Hero.jpg";
import whyChooseImage2 from "../../assets/images/Pune-event.JPG";
import whyChooseImage8 from "../../assets/images/Chandigarh-Event.JPG";
import whyChooseImage9 from "../../assets/images/Delhi-Event-2nd-edition.JPG";
import whyChooseImage3 from "../../assets/images/Hero.jpg";
import whyChooseImage4 from "../../assets/images/Delhi-Event.jpg";
import whyChooseImage5 from "../../assets/images/Launch-Day.jpg";
import whyChooseImage10 from "../../assets/images/be_a_shark.webp";
import whyChooseImage12 from "../../assets/images/WhatsApp-2.jpeg";
import aqtimage from "../../assets/images/JitanRamManjhi.webp";
import aqtimage2 from "../../assets/images/Bharatpreneur.webp";
import whyChooseImage13 from "../../assets/images/WhatsApp-3.jpeg";
import whyChooseImage11 from "../../assets/images/Sachin-K-sheoran.jpg";
import blog from "../../assets/images/blog-3.jpg";
import community from "../../assets/images/skyscrapers-from-low-angle-view2.webp";
import beshark from "../../assets/images/bearded-male.jpg";
import { useNavigate } from "react-router-dom";

const { Title, Paragraph, Text } = Typography;

const Shark = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMouseOver = (event) => {
    event.target.style.backgroundColor = "darkgreen";
  };

  const handleMouseOut = (event) => {
    event.target.style.backgroundColor = "green";
  };

  const carouselRef = React.useRef();
  const carouselRef2 = React.useRef();

  const handlePrev = () => {
    carouselRef.current.prev();
  };

  const handleNext = () => {
    carouselRef.current.next();
  };

  const handlePrev2 = () => {
    carouselRef2.current.prev();
  };

  const handleNext2 = () => {
    carouselRef2.current.next();
  };

  const sliderData = [
    {
      image: whyChooseImage3,
      title: "How To Become An Angel Investor",
      subheading:
        "Visionaries in Action: Driving Business Growth & Smart Investments",
    },
  ];
  
  const sliderData2 = [
    {
      image: whyChooseImage2,
      title: "Women Empowering",
      subheading: "Empowering Women, Fueling Innovation",
    },
    {
      image: whyChooseImage7,
      title: "Angel Investor Leaders",
      subheading: "Lead with Power, Dominate with Vision",
    },
    {
      image: whyChooseImage10,
      title: "Partnership with Investors",
      subheading: "Stronger Together, Investing in Success",
    },
    {
      image: aqtimage,
      title: "Shri Jitan Ram Manjhi",
      subheading: "Union Minister",
    },
    {
      image: aqtimage2,
      title: "Bharatpreneurs 2025",
      subheading: "India's Biggest Growth Conclave for Entrepreneurs & SMEs",
    },
  ];

  const categories = [
    {
      icon: (
        <MoneyCollectOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />
      ),
      title: "Angel Investors",
      description: "Seeking high-return opportunities.",
    },
    {
      icon: <UserOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />,
      title: "Corporate Leaders",
      description: "Offering strategic mentorship and insights.",
    },
    {
      icon: <RocketOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />,
      title: "Founders",
      description: "Looking for funding, scalability, and networking.",
    },
    {
      icon: <TeamOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />,
      title: "Incubators & Accelerators",
      description: "Supporting investment readiness and scaling.",
    },
    {
      icon: <BankOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />,
      title: "Banks & Financial Institutions",
      description: "Providing financial support and funding.",
    },
    {
      icon: <MessageOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />,
      title: "Media & Influencers",
      description: "Amplifying SME and startup success stories.",
    },
    {
      icon: <BulbOutlined style={{ fontSize: "40px", color: "#2DBA71" }} />,
      title: "Aspiring Investors",
      description: "Exploring SME investments.",
    },
  ];

  const features = [
    {
      icon: <RocketOutlined style={{ fontSize: "40px" }} />,
      title: "Investment-Ready SMEs & Startups",
      description:
        "Only high-growth potential businesses are selected for the platform.",
    },
    {
      icon: <ClusterOutlined style={{ fontSize: "40px" }} />,
      title: "Early Access to Promising Ventures",
      description:
        "Identify and invest in India's most promising SMEs and startups.",
    },
    {
      icon: <TeamOutlined style={{ fontSize: "40px" }} />,
      title: "Premium Business Networking",
      description: "Connect with industry leaders and market pioneers.",
    },
    {
      icon: <BarChartOutlined style={{ fontSize: "40px" }} />,
      title: "Data-Driven Investment Insights",
      description: "Make informed decisions backed by deep market research.",
    },
    {
      icon: <FundOutlined style={{ fontSize: "40px" }} />,
      title: "Flexible Investment Models",
      description: "Start small, co-invest, or invest significantly.",
    },
  ];

  const goToSharkForm = () => {
    window.scrollTo(0, 0);
    navigate("/angel-investor-form");
  };

  return (
    <div>
      <Navbar />
      
      {/* Hero Section - Reduced Size with Updated Text */}
      <div style={{ position: "relative", overflow: "hidden" }}>
        <Carousel
          ref={carouselRef}
          autoplay
          autoplaySpeed={2000}
          effect="fade"
          dotPosition="bottom"
          style={{ height: isMobile ? "400px" : "500px" }}
        >
          {sliderData.map((item, index) => (
            <div key={index}>
              <div
                style={{
                  backgroundImage: `url(${item.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center top",
                  height: isMobile ? "400px" : "500px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                ></div>
                <div
                  style={{
                    position: "relative",
                    textAlign: "center",
                    zIndex: 2,
                    padding: "0 20px",
                    maxWidth: "900px",
                  }}
                >
                  <Title
                    level={1}
                    style={{
                      color: "#fff",
                      fontSize: isMobile ? "32px" : "56px",
                      fontWeight: "bold",
                      textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8)",
                      marginBottom: "20px",
                      lineHeight: "1.2",
                    }}
                  >
                    {item.title}
                  </Title>
                  <Paragraph
                    style={{
                      fontSize: isMobile ? "18px" : "24px",
                      color: "#fff",
                      textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8)",
                      marginTop: "10px",
                      maxWidth: "800px",
                      margin: "0 auto",
                    }}
                  >
                    {item.subheading}
                  </Paragraph>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>

      {/* Introduction Section */}
      <div
        style={{
          padding: "40px 20px",
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <Title
          level={1}
          style={{
            fontWeight: "bold",
            marginBottom: "20px",
            color: "#333",
            fontSize: isMobile ? "28px" : "32px",
          }}
        >
          AQT Angel Investor Network – Invest. Network. Lead.
        </Title>

        <Paragraph
          style={{
            fontSize: isMobile ? "14px" : "16px",
            color: "#555",
            marginBottom: "30px",
            maxWidth: "900px",
            margin: "0 auto 30px",
          }}
        >
          Investing isn't just limited to Shark Tank—discover how real investors
          spot opportunities, structure deals, <br></br>and build successful
          businesses with Angel Investor.
        </Paragraph>

        <Divider style={{ marginBottom: "30px" }} />

        <Row
          gutter={[16, 16]}
          style={{
            marginBottom: "30px",
            marginLeft: isMobile ? "20px" : "94px",
            marginRight: isMobile ? "20px" : "119px",
          }}
        >
          <Col xs={24} sm={8} md={8}>
            <CheckCircleOutlined
              style={{
                fontSize: "24px",
                color: "#1890ff",
                marginBottom: "10px",
              }}
            />
            <Paragraph style={{ fontSize: isMobile ? "14px" : "16px", color: "#333" }}>
              Invest in High-Growth SMEs
            </Paragraph>
          </Col>
          <Col xs={24} sm={8} md={8}>
            <CheckCircleOutlined
              style={{
                fontSize: "24px",
                color: "#1890ff",
                marginBottom: "10px",
              }}
            />
            <Paragraph style={{ fontSize: isMobile ? "14px" : "16px", color: "#333" }}>
              Network with Elite Investors
            </Paragraph>
          </Col>
          <Col xs={24} sm={8} md={8}>
            <CheckCircleOutlined
              style={{
                fontSize: "24px",
                color: "#1890ff",
                marginBottom: "10px",
              }}
            />
            <Paragraph style={{ fontSize: isMobile ? "14px" : "16px", color: "#333" }}>
              Scale Businesses, Maximize Returns
            </Paragraph>
          </Col>
        </Row>
      </div>

      {/* Second Carousel */}
      <div style={{ position: "relative", overflow: "hidden" }}>
        <Carousel
          ref={carouselRef2}
          autoplay
          autoplaySpeed={2000}
          effect="fade"
          dotPosition="bottom"
          style={{ height: isMobile ? "500px" : "700px" }}
        >
          {sliderData2.map((item, index) => (
            <div key={index}>
              <div
                style={{
                  backgroundImage: `url(${item.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center top",
                  height: isMobile ? "500px" : "700px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                  }}
                ></div>
                <div
                  style={{
                    position: "relative",
                    textAlign: "center",
                    zIndex: 2,
                    padding: "0 20px",
                  }}
                >
                  <Title
                    level={2}
                    style={{
                      color: "#fff",
                      fontSize: isMobile ? "28px" : "36px",
                      fontWeight: "bold",
                      textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8)",
                    }}
                  >
                    {item.title}
                  </Title>
                  <Paragraph
                    style={{
                      fontSize: isMobile ? "16px" : "20px",
                      color: "#fff",
                      textShadow: "2px 2px 8px rgba(0, 0, 0, 0.8)",
                      marginTop: "20px",
                    }}
                  >
                    {item.subheading}
                  </Paragraph>
                </div>
              </div>
            </div>
          ))}
        </Carousel>

        <Button
          shape="circle"
          icon={<LeftOutlined />}
          onClick={handlePrev2}
          style={{
            position: "absolute",
            top: "50%",
            left: "20px",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            border: "none",
          }}
        />

        <Button
          shape="circle"
          icon={<RightOutlined />}
          onClick={handleNext2}
          style={{
            position: "absolute",
            top: "50%",
            right: "20px",
            transform: "translateY(-50%)",
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "#fff",
            border: "none",
          }}
        />
      </div>

      {/* About Section */}
      <div
        className="about-section"
        style={{
          position: "relative",
          padding: isMobile ? "40px 20px" : "40px 20px",
          backgroundImage: `url(${whyChooseImage7})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          color: "#fff",
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
          minHeight: "25vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1,
          }}
        ></div>

        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: "800px",
            textAlign: "center",
            padding: "0 20px",
          }}
        >
          <Title
            level={1}
            style={{
              color: "#fff",
              fontWeight: "bold",
              marginBottom: "20px",
              fontSize: isMobile ? "28px" : "32px",
            }}
          >
            About Angel Investor
          </Title>

          <Divider
            style={{
              borderColor: "#fff",
              width: "60px",
              margin: "20px auto",
              backgroundColor: "#fff",
            }}
          />
          <Row gutter={[32, 32]} justify="center" align="middle">
            <Col xs={24} md={24}>
              <Paragraph
                className="about-description"
                style={{
                  fontSize: isMobile ? "14px" : "16px",
                  lineHeight: "1.8",
                  textAlign: "center",
                  marginBottom: "20px",
                }}
              >
                Angel Investor is a strategic investment and networking platform by
                AQT Direct, designed to connect high-growth SMEs and startups
                with visionary investors. This initiative offers a structured
                approach to discovering, evaluating, and investing in disruptive
                businesses across multiple industries.
              </Paragraph>
              <Paragraph
                className="about-description"
                style={{
                  fontSize: isMobile ? "16px" : "18px",
                  lineHeight: "1.8",
                  textAlign: "center",
                }}
              >
                Angel Investor creates an ecosystem where investors, corporate
                leaders, industry pioneers, and SME founders collaborate to
                unlock new business opportunities, foster innovation, and build
                scalable success stories.
              </Paragraph>
            </Col>
          </Row>
        </div>
      </div>

      {/* Why Choose Section */}
      <div className="why-choose-section" style={{ padding: isMobile ? "40px 20px" : "40px 20px" }}>
        <Title
          level={2}
          style={{
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
            color: "#333",
            fontSize: isMobile ? "28px" : "32px",
          }}
        >
          Why Choose Angel Investor
        </Title>
        <Box
          width={150}
          height={3}
          bgcolor="#0f766e"
          mx="auto"
          mt={1}
          style={{ marginBottom: "30px" }}
        />
        <Row
          gutter={[24, 24]}
          justify="center"
          style={{ 
            marginTop: "20px", 
            marginLeft: isMobile ? "20px" : "77px", 
            marginRight: isMobile ? "20px" : "63px" 
          }}
        >
          {[
            {
              icon: <PieChartOutlined style={{ fontSize: "48px", color: "#2DBA71" }} />,
              title: "Curated SME & Startup Investments",
              description:
                "Access a pre-vetted portfolio of high-potential SMEs and startups across various sectors.",
            },
            {
              icon: <TeamOutlined style={{ fontSize: "48px", color: "#2DBA71" }} />,
              title: "Elite Business Networking",
              description:
                "Connect with investors, corporate leaders, and market disruptors in a structured environment.",
            },
            {
              icon: <BarChartOutlined style={{ fontSize: "48px", color: "#2DBA71" }} />,
              title: "Data-Driven Investment Decisions",
              description:
                "Leverage expert insights, financial analytics, and structured deal-making platforms for informed investments.",
            },
            {
              icon: <RocketOutlined style={{ fontSize: "48px", color: "#2DBA71" }} />,
              title: "Scale Businesses, Maximize Returns",
              description:
                "Support SMEs and startups with strong market traction and high-growth potential.",
            },
            {
              icon: <BookOutlined style={{ fontSize: "48px", color: "#2DBA71" }} />,
              title: "Industry Access & Thought Leadership",
              description:
                "Gain visibility through expert panels, masterclasses, and exclusive investor circles.",
            },
            {
              icon: <ToolOutlined style={{ fontSize: "48px", color: "#2DBA71" }} />,
              title: "Post-Investment Growth & Mentorship",
              description:
                "Beyond funding, benefit from strategic partnerships, mentorship, and media amplification.",
            },
          ].map((item, index) => (
            <Col xs={24} sm={12} md={8} key={index}>
              <div
                style={{
                  padding: "20px",
                  borderRadius: "12px",
                  backgroundColor: "#f9f9f9",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  textAlign: "center",
                  cursor: "pointer",
                  height: "100%",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 20px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 12px rgba(0, 0, 0, 0.1)";
                }}
              >
                <div style={{ marginBottom: "16px", color: "#2DBA71" }}>{item.icon}</div>
                <Title
                  level={4}
                  style={{
                    fontSize: isMobile ? "16px" : "18px",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  {item.title}
                </Title>
                <Paragraph
                  style={{ fontSize: isMobile ? "14px" : "16px", color: "#666", marginTop: "10px" }}
                >
                  {item.description}
                </Paragraph>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* How It Works Section */}
      <div
        className="agenda-slide"
        style={{
          width: "100%",
          padding: isMobile ? "40px 20px" : "40px 20px",
          backgroundColor: "#353d4e",
          color: "white",
          margin: "0px",
          boxSizing: "border-box",
        }}
      >
        <div
          className="header"
          style={{
            textAlign: "center",
            marginBottom: "40px",
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? "28px" : "32px",
              fontWeight: "bold",
              color: "white",
              marginBottom: "10px",
            }}
          >
            How It Works
          </h1>
          <p style={{ fontSize: isMobile ? "16px" : "18px", color: "#a0aec0" }}>
            Discover the seamless process of investment and growth.
          </p>
        </div>

        <Row
          gutter={[40, 40]}
          align="middle"
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            margin: "0 auto",
            maxWidth: "1200px",
          }}
        >
          <Col xs={24} sm={24} md={10} lg={8}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={blog}
                alt="How It Works"
                style={{
                  height: isMobile ? "300px" : "500px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </Col>

          <Col xs={24} sm={24} md={14} lg={16}>
            <div
              className="text-content"
              style={{
                fontSize: "16px",
                lineHeight: "1.8",
                paddingLeft: isMobile ? "0" : "51px",
              }}
            >
              <ul
                style={{
                  listStyleType: "none",
                  padding: 0,
                }}
              >
                {[
                  {
                    title: "Investor Engagement & Knowledge Sharing",
                    items: [
                      "Participate in exclusive investor meetups with top business leaders.",
                      "Access industry reports, strategic analysis, and market trends.",
                    ],
                  },
                  {
                    title: "Live SME & Startup Pitches & Deal Structuring",
                    items: [
                      "Direct access to SME and startup pitches and real-time evaluations.",
                      "Flexible investment models, including equity, revenue-sharing, and co-investment.",
                    ],
                  },
                  {
                    title: "Post-Investment Support & Scaling",
                    items: [
                      "Ongoing mentorship and growth strategy support for funded SMEs and startups.",
                      "Brand visibility and media coverage to amplify success stories.",
                    ],
                  },
                ].map((section, index) => (
                  <li key={index} style={{ marginBottom: "30px" }}>
                    <Card
                      hoverable
                      style={{
                        backgroundColor: "#2d3748",
                        border: "none",
                        borderRadius: "10px",
                        transition: "transform 0.3s ease",
                      }}
                      bodyStyle={{ padding: "20px" }}
                    >
                      <strong style={{ fontSize: isMobile ? "16px" : "18px", color: "#fff" }}>
                        {section.title}
                      </strong>
                      <ul
                        style={{
                          paddingLeft: "20px",
                          listStyleType: "disc",
                          marginTop: "10px",
                          fontSize: isMobile ? "14px" : "16px",
                        }}
                      >
                        {section.items.map((item, i) => (
                          <li key={i} style={{ color: "#a0aec0" }}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </Card>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </div>

      {/* Who Should Join Section */}
      <div style={{ padding: isMobile ? "40px 10px" : "40px 10px", backgroundColor: "#eeecec" }}>
        <Title
          level={2}
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontWeight: "bold",
            color: "#333",
            fontSize: isMobile ? "28px" : "32px",
          }}
        >
          Who Should Join
        </Title>
        <Box
          width={130}
          height={4}
          bgcolor="#2DBA71"
          mx="auto"
          mt={1}
          style={{ marginBottom: "30px" }}
        />
        <Row
          gutter={[10, 10]}
          justify="center"
          style={{ marginLeft: isMobile ? "10px" : "27px", marginRight: isMobile ? "10px" : "43px" }}
        >
          {categories.map((item, index) => (
            <Col key={index} xs={24} sm={12} md={6} lg={3}>
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  borderRadius: "10px",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  cursor: "pointer",
                  backgroundColor: "white",
                  height: "100%",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "translateY(-5px)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "translateY(0)")
                }
              >
                <div style={{ color: "#2DBA71", fontSize: "20px", marginBottom: "10px" }}>
                  {item.icon}
                </div>
                <Title
                  level={4}
                  style={{
                    fontSize: isMobile ? "14px" : "16px",
                    marginBottom: "5px",
                    color: "#000",
                  }}
                >
                  {item.title}
                </Title>
                <Text style={{ fontSize: isMobile ? "12px" : "13px", color: "#333" }}>
                  {item.description}
                </Text>
              </div>
            </Col>
          ))}
        </Row>
      </div>

      {/* Why Invest Section */}
      <div>
        <div
          style={{
            padding: isMobile ? "40px 20px" : "80px 20px",
            backgroundImage: `url(${community})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            textAlign: "center",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              zIndex: 1,
            }}
          ></div>

          <div style={{ position: "relative", zIndex: 2, width: "100%", maxWidth: "1200px" }}>
            <Title
              level={1}
              style={{
                fontWeight: "bold",
                marginBottom: isMobile ? "20px" : "30px",
                color: "#fff",
                fontSize: isMobile ? "28px" : "32px",
                padding: isMobile ? "0 10px" : "0",
              }}
            >
              Why Invest with Angel Investor
            </Title>
            <Divider
              style={{
                borderColor: "#fff",
                width: "60px",
                margin: isMobile ? "10px auto 20px" : "15px auto 30px",
              }}
            />
            <Row
              gutter={[20, 20]}
              justify="center"
              style={{
                margin: "0 auto",
                padding: isMobile ? "0 10px" : "0",
              }}
            >
              {features.map((feature, index) => (
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: isMobile ? "10px" : "20px",
                    flexDirection: isMobile ? "column" : "row",
                    textAlign: isMobile ? "center" : "left",
                  }}
                >
                  <div
                    style={{
                      marginRight: isMobile ? "0" : "20px",
                      marginBottom: isMobile ? "10px" : "0",
                      color: "#2DBA71",
                      fontSize: "40px",
                    }}
                  >
                    {feature.icon}
                  </div>
                  <div>
                    <Title
                      level={4}
                      style={{
                        fontSize: isMobile ? "16px" : "18px",
                        color: "#fff",
                        marginBottom: isMobile ? "5px" : "10px",
                      }}
                    >
                      {feature.title}
                    </Title>
                    <Text
                      style={{
                        fontSize: isMobile ? "14px" : "16px",
                        color: "#ddd",
                      }}
                    >
                      {feature.description}
                    </Text>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div
        style={{
          padding: isMobile ? "40px 20px" : "60px 20px",
          backgroundColor: "#f0f0f0",
          textAlign: "center",
        }}
      >
        <Title
          level={2}
          style={{
            color: "black",
            marginBottom: "20px",
            fontWeight: "bold",
            fontSize: isMobile ? "28px" : "32px",
          }}
        >
          Join Angel Investor Today
        </Title>
        <Paragraph
          style={{
            fontSize: isMobile ? "14px" : "16px",
            color: "black",
            marginBottom: "30px",
            maxWidth: "800px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          Angel Investor is redefining SME and startup investing by creating a
          structured, transparent, and high-impact funding ecosystem. Whether
          you are an experienced investor or new to SME and startup funding,
          this platform provides the right opportunities, resources, and
          networks to drive success.
        </Paragraph>
        <button
          style={{
            width: isMobile ? "150px" : "180px",
            backgroundColor: "green",
            color: "white",
            padding: isMobile ? "12px" : "12px 24px",
            borderRadius: "35px",
            border: "none",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
            marginTop: "16px",
            fontSize: isMobile ? "16px" : "18px",
            fontWeight: "600",
          }}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          onClick={goToSharkForm}
        >
          Join Now
        </button>
      </div>

      <Footer />
    </div>
  );
};

export default Shark;